import { render, staticRenderFns } from "./PackagePopup.vue?vue&type=template&id=2f8d3c42&scoped=true&"
import script from "./PackagePopup.vue?vue&type=script&lang=js&"
export * from "./PackagePopup.vue?vue&type=script&lang=js&"
import style0 from "./PackagePopup.vue?vue&type=style&index=0&id=2f8d3c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d3c42",
  null
  
)

export default component.exports